/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JobTitle
 */
export interface JobTitle {
    /**
     * 
     * @type {string}
     * @memberof JobTitle
     */
    value: string;
}

/**
 * Check if a given object implements the JobTitle interface.
 */
export function instanceOfJobTitle(value: object): value is JobTitle {
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function JobTitleFromJSON(json: any): JobTitle {
    return JobTitleFromJSONTyped(json, false);
}

export function JobTitleFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobTitle {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
    };
}

export function JobTitleToJSON(value?: JobTitle | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'value': value['value'],
    };
}

